/* eslint-disable no-console */
const Logger = {
  log: (...data) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(...data);
    }
  },
  error: (...data) => {
    if (process.env.NODE_ENV === 'development') {
      console.error(...data);
    }
  },
  warn: (...data) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn(...data);
    }
  },
  info: (...data) => {
    if (process.env.NODE_ENV === 'development') {
      console.info(...data);
    }
  },
};

export default Logger;
